module.exports = __webpack_public_path__ + "./Justin_color_27a75d459fc215ff1c6fa514898933b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Justin_color.jpg
// module id = 590
// module chunks = 0